import React from 'react';
import { Row, Col } from 'antd';
import ScreensGroupFilterContainer from '../../containers/step2_settings/ScreensGroupFilterContainer';
import ScreensOutputSettingsContainer from '../../containers/step2_settings/ScreensOutputSettingsContainer';
import ScreensCollectionsContainer from '../../containers/step2_settings/ScreensCollectionsContainer';

const cardClassName = 'contentFilter campaingInfoCard customPanelStyleDisplays stepTwoCard';

const StepTwo = ({ enabledRenderRules, applyRelationOnScreens, allDisplaysAreOwn }) => {
  return (
    <>
      {/* Las tarjetas van dentro de un div (no en el Col) para que el gutter
          no quede incluido dentro del borde/sombra. El wrapper .stepTwoTop da la
          separación con los grupos de pantallas (el Row con gutter vertical usa
          márgenes negativos inline, no sirve poner margin-bottom en el Row). */}
      <div className="stepTwoTop">
        <Row type="flex" gutter={[16, 16]} className="stepTwoTopRow">
          {enabledRenderRules ? (
            <>
              <Col xs={24} sm={24} md={14} lg={15} xl={15}>
                <div className={cardClassName}>
                  <ScreensGroupFilterContainer />
                </div>
              </Col>
              <Col xs={24} sm={24} md={10} lg={9} xl={9}>
                <div className={cardClassName}>
                  <ScreensOutputSettingsContainer enabledRenderRules={enabledRenderRules} />
                </div>
              </Col>
            </>
          ) : (
            <Col xs={24}>
              <div className={cardClassName}>
                <ScreensGroupFilterContainer />
              </div>
            </Col>
          )}
        </Row>
      </div>
      <ScreensCollectionsContainer
        applyRelationOnScreens={applyRelationOnScreens}
        allDisplaysAreOwn={allDisplaysAreOwn}
        enabledRenderRules={enabledRenderRules}
      />
    </>
  );
};

export default StepTwo;
